export default [
  {
    // Req. 135.5.3: portal público de inscrição da pré-matrícula por processo (sem login). O
    // contrato sai do ENDEREÇO (a Kernel resolve pelo hostname); o ":contrato" antigo é ignorado.
    description: 'Inscrição - Pré-matrícula por processo',
    path: '/publicas/prematricula/inscricao/:contrato?',
    name: 'portal_prematricula',
    component: () => import('@/views/publicas/prematricula/PortalInscricao.vue'),
    meta: {
      isLegacy: true,
      requiresAuth: false,
    },
  },
  {
    // Req. 169: transparência (vagas e lista de espera consolidadas), sem login. A rede sai do
    // ENDEREÇO, como no portal de inscrição.
    description: 'Transparência - Pré-matrícula',
    path: '/publicas/prematricula/transparencia',
    name: 'transparencia_prematricula',
    component: () => import('@/views/publicas/prematricula/Transparencia.vue'),
    meta: {
      isLegacy: true,
      requiresAuth: false,
    },
  },
  {
    description: 'Inscrições - Pré-Matrículas',
    path: '/publicas/portais/prematricula/inscricoes/:protocolo?/:chave?',
    name: 'prematricula',
    component: () => import('@/views/publicas/portais/prematricula/inscricoes/index.vue'),
    meta: {
      isLegacy: true,
      requiresAuth: false,
    },
    goesToMenu: true,
  },
  {
    description: 'Relatório de Inscrições',
    path: '/publicas/portais/prematricula/listagem',
    name: 'rel_inscricoes',
    component: () => import('@/views/publicas/portais/prematricula/relatorios/rel_inscricoes.vue'),
    meta: {
      isLegacy: true
    },
    goesToMenu: true,
  },
    {
    description: 'Relatório Sintético de Inscrições',
    path: '/publicas/portais/prematricula/relatoriosintetico',
    name: 'rel_sintetico_inscricoes',
    component: () => import('@/views/publicas/portais/prematricula/relatorios/rel_sintetico.vue'),
    meta: {
      isLegacy: true
    },
    goesToMenu: true,
  },
]

